import { render, staticRenderFns } from "./OrdenMenu.vue?vue&type=template&id=51edf324&"
import script from "./OrdenMenu.vue?vue&type=script&lang=js&"
export * from "./OrdenMenu.vue?vue&type=script&lang=js&"
import style0 from "./OrdenMenu.vue?vue&type=style&index=0&id=51edf324&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports